import styles from "./ActionCell.module.scss";
import { SquareButton } from "@/frontend/shared/ui/Button";
import { DotsThreeIcon } from "@/frontend/shared/assets/icons";

export function ActionCell({ field, onChange }: { field: string; onChange: () => void }) {
  return (
    <SquareButton
      size="small"
      variant="secondary"
      onClick={(e) => {
        e.stopPropagation();
        onChange();
      }}
    >
      <DotsThreeIcon className={styles.threeDotsIcon} />
    </SquareButton>
  );
}
